<template>
  <div class="accountForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  // import { dateFormatter } from '@/common/js/util';
  // import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'accountForm',
    components: {
      baseForm,
    },
    props: ['canEdit', 'sysAccountList'],
    data() {
      return {
        baseData: {
          bankAccountNum: null,
          bankAccountName: null,
          bankAccountDesc: null,
          classCode: null,
          secondaryClassCode: null,
          generalLedgerAccount: null,
          currencyCode: null,
          bankConnectionFlag: null,
          creditLine: null,
          createBy: null,
          createUser: null,
          bankAccountStatus: null,
          clMarginRate: null,
          clIssueCostRate: null,
          clAcceptanceCostRate: null,
          //gmtCreate: null,
          sapBankAccountCode: null,
          isDefault: 'N',
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankAccountNum'),
            prop: 'bankAccountNum',
            placeholder: this.$t('bankAccountEdit.bankForm.bankAccountNumPlaceholder'),
            disabled: false,
            required: true,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankAccountName'),
            prop: 'bankAccountName',
            placeholder: this.$t('bankAccountEdit.bankForm.bankAccountNamePlaceholder'),
            disabled: false,
            required: true,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.bankAccountDesc'),
            prop: 'bankAccountDesc',
            placeholder: this.$t('bankAccountEdit.bankForm.bankAccountDescPlaceholder'),
            disabled: false,
            required: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'dict',
            label: this.$t('bankAccountEdit.bankForm.classCode'),
            prop: 'classCode',
            placeholder: this.$t('bankAccountEdit.bankForm.classCodePlaceholder'),
            disabled: false,
            required: true,
            clearable: true,
            dictType: 'bankClassCode',
          },
          {
            type: 'dict',
            label: this.$t('bankAccountEdit.bankForm.secondaryClassCode'),
            prop: 'secondaryClassCode',
            placeholder: this.$t('bankAccountEdit.bankForm.secondaryClassCodePlaceholder'),
            disabled: false,
            clearable: true,
            dictType: 'bankClassCode-2',
          },
          {
            // 总账科目
            type: 'searchTable',
            prop: 'generalLedgerAccount',
            searchType: 'account',
            isMultiple: true,
            label: this.$t('bankAccountEdit.bankForm.generalLedgerAccount'),
            currentValue:
              this.sysAccountList[0] &&
              this.sysAccountList.find((it) => it.accountCode == this.baseData.generalLedgerAccount)
                ? this.sysAccountList.find(
                    (it) => it.accountCode == this.baseData.generalLedgerAccount
                  ).accountDesc
                : this.baseData.generalLedgerAccount,
            required: true,
          },
          {
            // 账户币别
            type: 'dict',
            dictType: 'all_currency',
            label: this.$t('bankAccountEdit.bankForm.currencyCode'),
            prop: 'currencyCode',
            required: true,
            filterable: true,
          },
          {
            type: 'checkbox',
            label: this.$t('bankAccountEdit.bankForm.bankConnectionFlag'),
            prop: 'bankConnectionFlag',
          },
          {
            type: 'sixNumber',
            label: this.$t('bankAccountEdit.bankForm.creditLine'),
            prop: 'creditLine',
            disabled: false,
            required: false,
            clearable: true,
          },
          {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.createBy'),
            prop: 'createUser',
            placeholder: this.$t('bankAccountEdit.bankForm.createByPlaceholder'),
            disabled: true,
            required: true,
          },
          {
            type: 'dict',
            label: this.$t('bankAccountEdit.bankForm.bankAccountStatus'),
            prop: 'bankAccountStatus',
            placeholder: this.$t('bankAccountEdit.bankForm.bankAccountStatusPlaceholder'),
            disabled: true,
            required: true,
            dictType: 'bankAccountStatus',
          },
          {
            type: 'sixNumber',
            label: this.$t('bankAccountEdit.bankForm.clMarginRate'),
            prop: 'clMarginRate',
            disabled: false,
            required: false,
            clearable: true,
          },
          {
            type: 'sixNumber',
            label: this.$t('bankAccountEdit.bankForm.clIssueCostRate'),
            prop: 'clIssueCostRate',
            disabled: false,
            required: false,
            clearable: true,
          },
          {
            type: 'sixNumber',
            label: this.$t('bankAccountEdit.bankForm.clAcceptanceCostRate'),
            prop: 'clAcceptanceCostRate',
            disabled: false,
            required: false,
            clearable: true,
          },
          /* {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.gmtCreate'),
            prop: 'gmtCreate',
            placeholder: this.$t('bankAccountEdit.bankForm.gmtCreatePlaceholder'),
            disabled: true,
            required: true,
          }, */
          {
            type: 'input',
            label: this.$t('bankAccountEdit.bankForm.sapBankAccountCode'),
            prop: 'sapBankAccountCode',
            placeholder: this.$t('bankAccountEdit.bankForm.sapBankAccountCodePlaceholder'),
            required: true,
          },
          {
            type: 'dict',
            dictType: 'externalCustomerCode',
            label: this.$t('bankAccountList.table.isDefault'),
            prop: 'isDefault',
          },
        ];
      },
      rules() {
        return {};
      },
    },

    mounted() {
      if (!this.$route.query.id) {
        //this.baseData.gmtCreate = dateFormatter(new Date());
        this.baseData.createBy = this.userInfo.userCode;
        this.baseData.createUser = this.userInfo.userName;
      }
    },
    methods: {
      //基本数据表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'generalLedgerAccount') {
          this.generalLedgerAccountChange(value.generalLedgerAccount);
        }
      },
      generalLedgerAccountChange(val) {
        if (val && val.length > 0) {
          this.baseData.generalLedgerAccount = val[0].accountCode;
        } else {
          this.baseData.generalLedgerAccount = null;
        }
      },
      // 返回数据
      exportChildData(btnType) {
        this.baseData.bankAccountStatus = btnType;
        this.baseData.bankConnectionFlag = this.baseData.bankConnectionFlag ? 1 : 0;
        if (btnType == '001' || btnType == '002') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseData.$refs.ruleForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
